import { use } from "react";
import { UploadContext } from "lib/contexts/GlobalContexts/UploadContext";

export const useUploader = () => {
  return use(UploadContext);
};
